import { Factory } from "fishery";
import { toGlobalId } from "../utils/graphql_utils";
import type { SubscriptionAddressFullFragment } from "../graphql/supergraph.index";

type StateObjectType = NonNullable<SubscriptionAddressFullFragment["state"]>;
type CountryObjectType = NonNullable<SubscriptionAddressFullFragment["country"]>;
class StateObjectTypeFactory extends Factory<StateObjectType> {
  newYork() {
    return this.params({
      id: toGlobalId("StateObjectType", 1),
      code: "NY",
      name: "New York",
    });
  }

  colorado() {
    return this.params({
      id: toGlobalId("StateObjectType", 8),
      code: "CO",
      name: "Colorado",
    });
  }

  california() {
    return this.params({
      id: toGlobalId("StateObjectType", 9),
      code: "CA",
      name: "California",
    });
  }
}
const stateObjectTypeFactory = StateObjectTypeFactory.define(() => {
  // ideally we should use faker, but we can't use it due to
  // https://github.com/faker-js/faker/issues/2349
  // we would like to generate the same state for both code and name
  return {
    __typename: "StateObjectType" as const,
    id: "U3RhdGVPYmplY3RUeXBlOjMK",
    code: "PA",
    name: "Pennsylvania",
  };
});
class CountryObjectTypeFactory extends Factory<CountryObjectType> {
  usa() {
    return this.params({
      id: "Q291bnRyeU9iamVjdFR5cGU6MQ==",
      code: 1,
      alpha2code: "US",
      name: "United States",
    });
  }

  australia() {
    return this.params({
      id: "Q291bnRyeU9iamVjdFR5cGU6MTM=",
      code: 61,
      alpha2code: "AU",
      name: "Australia",
    });
  }
}
const countryObjectTypeFactory = CountryObjectTypeFactory.define(() => {
  return {
    __typename: "CountryObjectType" as const,
    id: "Q291bnRyeU9iamVjdFR5cGU6MTM=",
    code: 61,
    alpha2code: "AU",
    name: "Australia",
  };
});
class SubscriptionAddressFullFragmentFactory extends Factory<SubscriptionAddressFullFragment> {
  usa() {
    return this.params({
      region: null,
      city: "Philadelphia",
      postalCode: "19103",
    }).associations({
      state: stateObjectTypeFactory.build(),
      country: countryObjectTypeFactory.usa().build(),
    });
  }

  california() {
    return this.usa()
      .params({
        city: "San Francisco",
        postalCode: "94105",
      })
      .associations({
        state: stateObjectTypeFactory.california().build(),
      });
  }

  colorado() {
    return this.usa()
      .params({
        city: "Denver",
        postalCode: "80014",
      })
      .associations({
        state: stateObjectTypeFactory.colorado().build(),
      });
  }

  australia() {
    return this.params({
      region: "New South Wales",
      city: "Sydney",
      postalCode: "2010",
    }).associations({
      state: null,
      country: countryObjectTypeFactory.australia().build(),
    });
  }
}

export const subscriptionAddressFactory = SubscriptionAddressFullFragmentFactory.define(
  ({ associations }) => {
    return {
      __typename: "SubscriptionAddressObjectType" as const,
      street: "15 Main St",
      street2: "Unit 11",
      street3: "Apt 7",
      city: "Sydney",
      region: "New South Wales",
      state: associations.state ?? null,
      postalCode: "2010",
      country: associations.country ?? countryObjectTypeFactory.australia().build(),
    };
  },
);
